import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'
import online from './status.js';
const db = online ? firebase.firestore() : false;
export default db;